import {
  IAsyncDropdownModel,
  IDropdownModel,
} from "common/models/IDropdownModel";
import dayjs from "dayjs";
import { z } from "zod";

export const AccessionBarCodeSchema = z.object({
  // accessionNo: z.string().nullable(),
  accessionNoValues: z.array(z.string()).nullable().optional(),
  accessionNo: z
    .array(
      z.object({
        id: z.string(),
        name: z.string(),
      })
    )
    .nullish(),
  accessionNoString: z.array(z.string()).nullable().optional(),
  accessionNoStringValue: z
    .string()
    .nullish()
    .transform((val) => (val == "" ? null : val)),
  accessionValueType: z.coerce.number({
    message: "Select One",
    required_error: "Select One",
  }),
  materialID: z.string().nullish(),
  materialValue: z.custom<IAsyncDropdownModel>(),
  rackID: z.string().nullish(),
  rackValue: z.custom<IAsyncDropdownModel>(),
  supplierID: z.string().nullish(),
  supplierValue: z.custom<IDropdownModel>(),
  sectionID: z.string().nullish(),
  materialStatusID: z.string().nullish(),
  instituteID: z.string().nullish(),
  departmentID: z.string().nullish(),
  programID: z.string().nullish(),
  entryDate: z.coerce
    .string()
    .transform((c) => (c === "null" ? null : c))
    .transform((c) => (c === "undefined" ? null : c))
    .refine((c) => (!c && c != null ? dayjs(c).isValid() : true), {
      message: "Invalid date",
    }),
  barCodeFormats: z.coerce.number({
    message: "Select Format",
    required_error: "Select Format",
  }),
  isReports: z.boolean(),
  isBorder: z.boolean(),
  contentFormats: z.coerce.number({
    message: "Select Type",
    required_error: "Select Type",
  }),
});

export type IAccessionBarCodeSchema = z.infer<typeof AccessionBarCodeSchema>;

export const MemberBarCodeSchema = z.object({
  instituteID: z.string().nullish(),
  departmentID: z.string().nullish(),
  programID: z.string().nullish(),
  entryDate: z.coerce
    .string()
    .transform((c) => (c === "null" ? null : c))
    .transform((c) => (c === "undefined" ? null : c))
    .refine((c) => (!c && c != null ? dayjs(c).isValid() : true), {
      message: "Invalid date",
    }),
  memberStatusID: z.string().nullish(),
  memberTypeID: z.string().nullish(),
  admissionYearID: z.string().nullish(),
  filterRadioBtn: z.coerce.number({
    message: "Select One",
    required_error: "Select One",
  }),
  barCodeFormats: z.coerce.number({
    message: "Select Format",
    required_error: "Select Format",
  }),
  isReports: z.boolean(),
  isBorder: z.boolean(),
  contentFormats: z.coerce.number().nullish(),
  memberCodeValues: z.array(z.string()).nullable().optional(),
  memberCode: z
    .array(
      z.object({
        value: z.string(),
        label: z.string(),
      })
    )
    .nullish(),
  memberCodeString: z.array(z.string()).nullable().optional(),
  memberCodeStringValue: z
    .string()
    .nullish()
    .transform((val) => (val == "" ? null : val)),
  memberCodeValueType: z.coerce.number({
    message: "Select One",
    required_error: "Select One",
  }),
});

export type IMemberBarCodeSchema = z.infer<typeof MemberBarCodeSchema>;
